import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TypesErrors } from '@app/enums/errors.enum';
import { Reservation } from '@app/models/micro/reservation.model';
import { IropsService } from '@app/services/micro/irops.service';
import { MessagesService } from '@app/services/messages.service';
import { GlobalsService } from '@app/services/micro/globals.service';
import { messageParamsGeneric } from '@app/utils';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {ErrorModel} from "@models/micro/error.model";

type CloseOrigin = 'close' | 'cancel' | 'continue';
@Component({
    selector: 'irops-delete-chk-modal',
    templateUrl: './irops-delete-chk-modal.component.html',
    styleUrls: ['./irops-delete-chk-modal.component.scss'],
    standalone: false
})
export class IropsDeleteCHKModalComponent implements OnInit {
  reservation: Reservation;

  constructor(
    private modalService: NgbModal,
    private _router: Router,
    private _globalService: GlobalsService,
    private iropsService: IropsService,
    private _messages: MessagesService,
  ) { }

  ngOnInit() {
    this.reservation = this._globalService.getReservation();
  }

  closeModal(origin:CloseOrigin) {
    this.modalService.dismissAll(origin);
  }

  get hasPaxCki() {
    return this.reservation?.passengers?.some(p => p.checkinStatus);
  }

  onContinue() {
    this.closeModal('continue');

    if(this.hasPaxCki) {
       this.removeCheckIn();
    }else {
       this._router.navigate(['notice-proposed-flight']);
    }
  }



  removeCheckIn(): void {
    this.iropsService.removeCHKN(this.reservation).subscribe({
      next: (response) => {
        if (response.status === 'success') {
          this.closeModal("continue")
          setTimeout(
            () => {
              this._router.navigate(['notice-proposed-flight']);
            },
            0
          )


        }
      },
      error: (err) => {
        this.showMessageBlock()
      }
    })
  }

  private handleError(): void {
    this.showMessageBlock();
  }

  private showMessageBlock(): void {
    const error = new ErrorModel().withCode('99').withMessage('Error in remove check-in');
    this._messages.error(
      {
        typesError: TypesErrors.ERROR_IN_REMARK,
        error
      },
      null,
      TypesErrors.ERROR_IN_REMARK,
      messageParamsGeneric
    ).finally(()=>{
      this.closeModal("close");
      this._router.navigate(['/']);
    });
  }
}
